"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useLaunchDarkly", {
  enumerable: true,
  get: function get() {
    return _useLaunchDarkly["default"];
  }
});
var _useLaunchDarkly = _interopRequireDefault(require("./useLaunchDarkly"));